<p-accordion class="optimize-tabs" [multiple]="true">
  <p-accordionTab header="Optimization Details" [selected]="true">
    <div class="gbp-photo-scheduled-optimized-body-wrapper">
      <div class="details-col text">
        <div class="details-row" *ngFor="let item of receivedData['details']; let i = index">
          <div class="flex-title">{{ item.name }}</div>
          <div class="flex-input">
            <input
              *ngIf="edit; else textField"
              class="flex-input-field"
              type="text"
              [(ngModel)]="item.data"
              pInputText
              placeholder="Type Here..."
            />
            <ng-template #textField>{{ item.data }}</ng-template>
          </div>
          <div *ngIf="!detailsOptimize" class="flex-icon">
            <i
              class="pi pi-question-circle"
              pTooltip="{{ receivedData['tooltipsText'][i].text }}"
              tooltipPosition="left"
            ></i>
          </div>
        </div>
      </div>
      <div *ngIf="detailsOptimize" class="details-col image">
        <img src="https://picsum.photos/100/100?random=10" alt="photo" />
      </div>
    </div>
  </p-accordionTab>
  <p-accordionTab header="Advanced">
    <ng-template pTemplate="header"
      ><span class="optimize-tab-advanced"
        >(This information is auto-generated and can be edited if required)</span
      ></ng-template
    >
    <ng-template pTemplate="content">
      <div class="gbp-photo-scheduled-optimized-body-wrapper">
        <div class="details-col">
          <div class="details-row" *ngFor="let item of receivedData['advanced']">
            <div class="flex-title">{{ item.name }}</div>
            <div [ngClass]="detailsOptimize ? 'flex-input' : 'flex-input-advanced'">
              <input
                *ngIf="edit; else textFieldAdvanced"
                class="flex-input-field"
                type="text"
                [(ngModel)]="item.data"
                pInputText
                placeholder="Type Here..."
              />
              <ng-template #textFieldAdvanced>{{ item.data }}</ng-template>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-accordionTab>
  <p-accordionTab header="Details" [selected]="true" *ngIf="detailsOptimize">
    <ng-template pTemplate="header"
      ><span *ngIf="dynamicDialogConfig.data.activity.status == activityStatus.PUBLISHED" class="optimize-tab-advanced"
        >(You cannot edit details of a published photo)</span
      ></ng-template
    >
    <ng-template pTemplate="content">
      <div
        *ngIf="!edit || dynamicDialogConfig.data.activity.status == activityStatus.PUBLISHED; else editSchedule"
        class="gbp-photo-scheduled-optimized-body-wrapper"
      >
        <div class="details-row">
          <div class="flex-title">Date</div>
          <div class="flex-input">14/02/2022 05:32 PM GMT+2</div>
        </div>
        <div class="details-row">
          <div class="flex-title">Locations</div>
          <div class="flex-input-link" (click)="openLocations()">23 locations selected</div>
        </div>
      </div>
    </ng-template>
  </p-accordionTab>
</p-accordion>

<ng-template #editSchedule
  ><app-gbp-date-locations-form [scheduleGroup]="scheduleGroup" [rows]="2"></app-gbp-date-locations-form
></ng-template>
